
function initListFilter() {
    const filters = document.querySelectorAll('.filter');

    filters.forEach(filter => {

        filter.addEventListener('click', function() {

            var current = document.getElementsByClassName("active");
            current[0].className = current[0].className.replace(" active", "");
            this.className += " active";

            let selectedFilter = filter.getAttribute('data-filter');
            let itemsToHide = document.querySelectorAll(`.filter-parent .filter-child:not([data-filter='${selectedFilter}'])`);
            let itemsToShow = document.querySelectorAll(`.filter-parent [data-filter='${selectedFilter}']`);

            if (selectedFilter == 'all') {
                itemsToHide = [];
                itemsToShow = document.querySelectorAll('.filter-parent [data-filter]');
            }

            itemsToHide.forEach(el => {
                el.classList.add('hide');
                el.classList.remove('show');
            });

            itemsToShow.forEach(el => {
                el.classList.remove('hide');
                el.classList.add('show');
            });

        });
    });
}

export default initListFilter;
